import _ from 'lodash';
import { ObjectTableColumnKey } from './column-util/object-table-column-util';
import { ColumnWidthType, RowHeightType } from './object-table.interface';
export const HEADER_HEIGHT = 32;
/**
 * getFlexValue() method will be used to get the
 * @param columnWidth
 * @returns
 */
export const getFlexValue = (columnWidth) => {
    return columnWidth / 40;
};
export const isColumnSortable = (columnField) => {
    if (columnField === ObjectTableColumnKey.PrimaryName ||
        columnField === ObjectTableColumnKey.Tags ||
        columnField === ObjectTableColumnKey.Author ||
        columnField === ObjectTableColumnKey.LastAccessed) {
        return true;
    }
    return false;
};
export const isColumnFiltrable = (columnField) => {
    if (columnField === ObjectTableColumnKey.Type ||
        columnField === ObjectTableColumnKey.Verified ||
        columnField === ObjectTableColumnKey.Favorite ||
        columnField === ObjectTableColumnKey.Tags ||
        columnField === ObjectTableColumnKey.Author) {
        return true;
    }
    return false;
};
/**
 * The overrideColDef method will override to the standardized column dimensions.
 *
 * @param objectTableColDef column definitions will be override.
 * @returns colDef
 */
export const getColDef = (objectTableColDef) => {
    var _a;
    const sortable = isColumnSortable((_a = objectTableColDef.colDef) === null || _a === void 0 ? void 0 : _a.field);
    // Common colDef properties
    const commonColDef = {
        sortable,
        resizable: false,
        suppressSizeToFit: true,
        suppressAutoSize: true,
        suppressMovable: true,
    };
    let colDef = {
        ...objectTableColDef.colDef,
        ...commonColDef,
    };
    if (objectTableColDef.columnWidthType === ColumnWidthType.Fixed) {
        const fixedDimensions = {
            width: objectTableColDef.columnWidth,
        };
        colDef = {
            ...colDef,
            ...fixedDimensions,
        };
        delete colDef.minWidth;
        delete colDef.maxWidth;
        delete colDef.flex;
    }
    else if (objectTableColDef.columnWidthType === ColumnWidthType.Fluid) {
        const fluidDimensions = {
            minWidth: objectTableColDef.columnWidth,
            flex: getFlexValue(objectTableColDef.columnWidth),
            suppressSizeToFit: false,
        };
        colDef = {
            ...colDef,
            ...fluidDimensions,
        };
        delete colDef.width;
        delete colDef.maxWidth;
    }
    if (objectTableColDef.rowHeightType === RowHeightType.Fixed) {
        const fixedHeightProps = {};
        colDef = {
            ...colDef,
            ...fixedHeightProps,
        };
        delete colDef.autoHeight;
    }
    else if (objectTableColDef.rowHeightType === RowHeightType.Auto) {
        const extendedHeightProps = {
            autoHeight: true,
        };
        colDef = {
            ...colDef,
            ...extendedHeightProps,
        };
    }
    return colDef;
};
/**
 * getColDefs() method is used to get the overrided the ColDef properties.
 * @param objectTableColDefs
 * @returns List of ColDef
 */
export const getColDefs = (objectTableColDefs) => {
    if (_.isNil(objectTableColDefs))
        return [];
    return objectTableColDefs.map((objectTableColDef) => getColDef(objectTableColDef));
};
//# sourceMappingURL=object-table.util.js.map